export default {
	0: "BankBillet",
	1: "CreditCard",
	2: "Pix"
};
